module.exports = new __parcel__URL__("kill-bill-vol-2.7d39c5ce.jpg").toString();